// extracted by mini-css-extract-plugin
export var barContainer = "_10-0";
export var extraThin = "_10-3";
export var fillBar = "_10-6";
export var fillContainer = "_10-4";
export var overflow = "_10-8";
export var overflowContainer = "_10-5";
export var regular = "_10-7";
export var thick = "_10-1";
export var thin = "_10-2";